/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import userActions from 'redux/actions/user';
import navigationActions from 'redux/actions/navigation';

import userSelectors from 'redux/reduxStore/user';
import groupSelectors from 'redux/reduxStore/group';

import LoginEmailView from './LoginEmail.view';
import routeNames from 'lib/routeNames';

import { validateEmail } from 'lib/validators';

function mapStateToProps(state) {
  const group = groupSelectors.getActiveGroup(state) || {};
  return {
    email: userSelectors.getEmail(state) || '',
    groupName: group.name || '',
    organizationName: group.organization_name || '',
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateEmail: (email) => {
      dispatch(userActions.updateEmail(email));
    },
    goToPassword: () => {
      dispatch(navigationActions.goBackTo(routeNames.loginPassword()));
    }
  }
}

class LoginEmailPresenter extends React.Component {

  constructor(props) {
    super(props);

    this.submitEmail = this.submitEmail.bind(this);
    this.isValidEmail = this.isValidEmail.bind(this);

    this.state = {
      invalidPhrase: {},
    };
  }

  isValidEmail() {
    return validateEmail(this.props.email);
  }

  submitEmail(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.isValidEmail()) {
      this.setState({
        invalidPhrase: {
          id: 'error.email-validator.invalid-email.message',
        },
      });
      return;
    }

    this.props.goToPassword();
  }

  render() {
    return (
      <LoginEmailView
        email={this.props.email}
        organizationName={this.props.organizationName}
        submitEmail={this.submitEmail}
        updateEmail={(email) => {
          this.props.updateEmail(email);
          this.setState({ invalidPhrase: {} });
        }}
        isValidEmail={this.isValidEmail()}
        groupName={this.props.groupName}
        isInvalid={!!this.state.invalidPhrase.id}
        invalidPhrase={this.state.invalidPhrase}
      />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginEmailPresenter);